
import $ from "jquery"

import Notifier from "app/notifier/index"
import Auth_action from "app/authentication/action"
import Auth_state from "app/authentication/state"
import Auth_callback_queue from "app/authentication/callback_queue"

import Track_ee from "../tracking/index"

interface Selector {
  scope:    string | Element
  section:  string
  info_box: string
  btn:      string
}
interface InputSelector {
  scope?:    string | Element
  section?:  string
  info_box?: string
  btn?:      string
}
const default_selector = {
  scope:    ".cell-listing-contact-request-box",
  section:  ".cell--listing--contact--request--box--contact-phone",
  info_box: ".cell--listing--contact--request--box--contact-phone__hidden-info",
  btn:      ".cell--listing--contact--request--box--contact-phone--link",
}

const init = (selector?: InputSelector) => {
  const sele: Selector = Object.assign({}, default_selector, selector)
  const $scope = $(sele.scope)
  const $section = $scope.find(sele.section)
  const $btns = $section.find(sele.btn)
  const message_no_login_no_contact_phone = $scope.data("message-no-login-no-contact-phone")

  $btns.on("click", (e) => {
    e.preventDefault()
    const $this = $(e.currentTarget)

    Track_ee.emit("show_phone_btn_click", $this.data("listing-id"))

    if (Auth_state.isSignedOut()){
      Notifier.showWarning(message_no_login_no_contact_phone)
      Auth_action.showSignUpModal().done()

      const on_sign_in_event_listener = () => {
        $section.addClass("show_info")
        Track_ee.emit("phone_btn_success_submit", $this.data("listing-id"), $this.data("is-rental"), $this.data("is-commercial"))
      }

      const slot_name = `cell-listing-contact-request-box__show_contact_phone__${(new Date()).getTime()}`
      Auth_callback_queue.add(on_sign_in_event_listener, slot_name)

      // # If not signed in in 5 mins, no autobutton reveal
      setTimeout(() => {
        Auth_callback_queue.remove(slot_name)
      }, 5 * 60 * 1000)
      return
    }

    $section.addClass("show_info")
    Track_ee.emit("phone_btn_success_submit", $this.data("listing-id"), $this.data("is-rental"), $this.data("is-commercial"))

  })
}

export default {init}
